import React, { useRef, isValidElement } from 'react';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Fade } from '../Fade/Fade.es.js';
import { Box } from '../../primitives/Box/Box.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Backdrop = styled(Box)`
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
    max-width: 100vw;
    max-height: 100%;
    background-color: ${palette("neutral.1000", 0.8)};
`;
const Content = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    height: 100%;
    overflow: hidden;
`;
const OverlayComponent = (_a) => {
  var _b = _a, {
    children,
    isVisible = false,
    onClick,
    position = "fixed",
    zIndex = "overlay",
    timeout = 300,
    transitionComponent: TransitionComponent = Fade,
    sx
  } = _b, props = __objRest(_b, [
    "children",
    "isVisible",
    "onClick",
    "position",
    "zIndex",
    "timeout",
    "transitionComponent",
    "sx"
  ]);
  const backdropElement = useRef(null);
  const handleBackdropClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const clickWasOnBackdrop = backdropElement && backdropElement.current === e.target;
    if (clickWasOnBackdrop) {
      onClick == null ? void 0 : onClick(e);
    }
  };
  return /* @__PURE__ */ React.createElement(TransitionComponent, {
    in: isVisible,
    timeout,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true
  }, /* @__PURE__ */ React.createElement(Backdrop, {
    ref: backdropElement,
    onClick: handleBackdropClick,
    position,
    zIndex,
    sx
  }, isValidElement(children) && /* @__PURE__ */ React.createElement(Content, __spreadValues({}, props), children)));
};
const Overlay = maestroComponent("Overlay", OverlayComponent);

export { Overlay };
//# sourceMappingURL=Overlay.es.js.map
